import 'npm/normalize.css/normalize.css'
import 'npm/animate.css/animate.css'
import '@/styles/reset.scss'
import '@/styles/base.scss'
import '@/styles/print.scss'



// WEBPACK FOOTER //
// ./src/initializers/styles.js